// extracted by mini-css-extract-plugin
module.exports = {"amountContent":"ProjectFormDiscountModal_amountContent__HgqwF","amount":"ProjectFormDiscountModal_amount__4Fr2_","amountLabel":"ProjectFormDiscountModal_amountLabel__U1Mfi"};